module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('img', {
    staticClass: "logo",
    style: ({
      height: _vm.size + 'px',
      width: _vm.size + 'px'
    }),
    attrs: {
      "src": _vm.logoUrl,
      "alt": _vm.altContext
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dc09f95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JsLogo.vue
// module id = 144
// module chunks = 1